import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../lib/utils";

const containerVariants = cva("mx-auto w-full px-6 md:px-12", {
  variants: {
    size: {
      /** Reading / form width. */
      sm: "max-w-[640px]",
      /** Compact sections. */
      md: "max-w-[980px]",
      /** Standard page section width. */
      lg: "max-w-[1200px]",
      /** Hero / detail modules that need extra room. */
      xl: "max-w-[1600px]",
      /** Edge-to-edge — keeps the shared horizontal padding only. */
      full: "max-w-none",
    },
  },
  defaultVariants: {
    size: "full",
  },
});

export interface ContainerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof containerVariants> {}

/**
 * Page-section wrapper — owns max-width centering and horizontal padding so
 * section components don't each hand-roll `mx-auto max-w-[…] px-…`.
 */
export const Container: React.FC<ContainerProps> = ({
  size,
  className,
  children,
  ...props
}) => (
  <div className={cn(containerVariants({ size }), className)} {...props}>
    {children}
  </div>
);
